// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

export type OtherUploadRoute = 'gdb' | 'shp' | 'deliverable';

// OTHER is the fallback output bucket: archives named as a geodatabase or shapefile keep their pipelines and everything
// else is a plain deliverable; null = a type with its own pipeline (dxf, las/laz, xml), left to the extension switch
export const otherUploadRoute = (fileName: string): OtherUploadRoute | null => {
  const name = fileName.toLowerCase();
  if (/\.(dxf|las|laz|xml)$/.test(name)) return null;
  if (/\.gdb\.(zip|rar)$/.test(name)) return 'gdb';
  if (/\.shp\.(zip|rar)$/.test(name)) return 'shp';
  return 'deliverable';
};
